import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUser3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.03 6.352a3.5 3.5 0 1 0-4.059 0A6 6 0 0 0 2 12h2l1 4h6l1-4h2a6 6 0 0 0-3.97-5.648\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUser3
